// extracted by mini-css-extract-plugin
export default {"wrapper":"WS-z","availablePromoMessagesLabel":"XS-z","promoMessageList":"YS-z","promoMessage":"ZS-z","appliedPromoMessage":"_S-z","promoMessageAmount":"aT-z"};